var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOfficeEdit = function SvgOfficeEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.005,
    height: 15.998,
    viewBox: "0 0 14.005 15.998",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "office_edit",
    d: "M16367,982a2,2,0,0,1-2-2V968a2,2,0,0,1,2-2h6.511l-1.5,1.5h-4.518a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1h9.006a1,1,0,0,0,1-1v-6.174l1.5-1.5V980a2,2,0,0,1-2,2Zm3.839-8v-1.685l4.661-4.661,1.686,1.681-4.665,4.666Zm5.3-6.984,1.015-1.015,1.686,1.685-1.02,1.015Z",
    transform: "translate(-16364.998 -966.001)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfficeEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/office_edit.dec8e308.svg";
export { ForwardRef as ReactComponent };